import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Button } from "@univdiam/ui/components/button";
import { DataTable } from "@univdiam/ui/customComponents/GroupMasterList/data-table";
import { groupColumns } from "@univdiam/ui/customComponents/GroupMasterList/columns";
import { EditGroupMasterForm } from "@univdiam/ui/customComponents/GroupMasterList/EditGroupMasterForm";

import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_SERVER_URL;

export default function GroupMasterPage() {
  const [data, setData] = useState([]);
  const [editGroupMasterData, setEditGroupMasterData] = useState(null);

  const fetchGroupMasters = () => {
    axios
      .get(`${API_BASE_URL}/api/group_masters`)
      .then((res) => {
        const transformed = res.data.data.map((group: any) => ({
          group_master_id: group.group_master_id,
          group_id: group.group_id,
          name: group.name,
          code: group.code || "",
          uom: group.uom || "",
          bom: group.bom || 0,
          status: group.status === 1 ? "Enabled" : "Disabled",
        }));
        setData(transformed);
      })
      .catch((err) => console.error("Failed to fetch groups", err));
  };

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/group_masters`)
    .then(res => {
      const transformed = res.data.data.map((group: any) => ({
        group_master_id: group.group_master_id.toString(),
        group_id: group.group_id.toString(),
        name: group.name,
        code: group.code || "",
        uom: group.uom || "",
        bom: group.bom || 0,
        status: group.status === 1 ? "Enabled" : "Disabled"
      }))
      setData(transformed)
    })
    .catch(err => console.error("Failed to fetch groups", err))

    fetchGroupMasters();
  }, []);

  const handleDelete = async (id: string) => {
    console.log(id)
    const confirm = window.confirm("Are you sure you want to delete this group?")
    if (!confirm) return

    try {
      const res = await axios.delete(`${API_BASE_URL}/api/group_masters/${id}`);
      if (res.status === 200) {
        alert("Group Master deleted successfully.");
        fetchGroupMasters(); // refresh after delete
      } else {
        alert("Failed to delete group.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Something went wrong.");
    }
  };

  const handleEdit = async (group: any) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/group_masters/${group.group_master_id}`);
      if (res.status === 200) {
        setEditGroupMasterData(res.data);
      } else {
        alert("Failed to fetch group.");
      }
    } catch (error) {
      console.error("Edit error:", error);
      alert("Something went wrong.");
    }
  };

  const navigate = useNavigate();

  const handleAddGroupMaster = () => {
    navigate("/group_masters/add");
  };

  const columns = groupColumns({ onEdit: handleEdit, onDelete: handleDelete });

  return (
    <div className="p-5">
      <div className="flex justify-between mb-4">
        <h1 className="text-xl font-semibold">Group Master Management</h1>
        <div className="flex justify-end mb-4">
          <Button onClick={handleAddGroupMaster}>+ Add Group Master</Button>
        </div>
      </div>
      <DataTable columns={columns} data={data} />
      {editGroupMasterData && (
        <EditGroupMasterForm
          group={editGroupMasterData}
          onCancel={() => setEditGroupMasterData(null)}
          onSave={() => {
            setEditGroupMasterData(null);
            fetchGroupMasters();
          }}
        />
      )}
    </div>
  );
}
